<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/purchase-orders"
          ></back-button>
          Add Purchase order
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`procurement-management/purchase-orders`"
              >Purchase order</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="purchase-order-tab"
                  data-bs-toggle="tab"
                  href="#purchase-order"
                  role="tab"
                  aria-controls="purchase-order"
                  aria-selected="true"
                  >Purchase order</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="purchase-orderDetial-tab"
                  data-bs-toggle="tab"
                  href="#purchase-orderDetial"
                  role="tab"
                  aria-controls="purchase-orderDetial"
                  aria-selected="false"
                  >Purchase order Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For Purchase order Sectiion -->
              <div
                class="tab-pane fade show active"
                id="purchase-order"
                role="tabpanel"
                aria-labelledby="purchase-order-tab"
              >
                <h4>Purchase order</h4>
                <hr />
                <purchase-order-form :form="form"></purchase-order-form>
              </div>
              <!-- For Requsition Details -->
              <div
                class="tab-pane fade"
                id="purchase-orderDetial"
                role="tabpanel"
                aria-labelledby="purchase-orderDetial-tab"
              >
                <h4>Purchase order Details</h4>
                <hr />
                <purchase-order-detail-form
                  :form="form"
                ></purchase-order-detail-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import PurchaseOrderForm from "../purchase-orders/purchase-order-form.vue";
import PurchaseOrderDetailForm from "../purchase-orders/purchase-order-detail-form.vue";
export default {
  components: { PurchaseOrderForm, PurchaseOrderDetailForm },
  name: "PurchaseOrderCreate",
  data() {
    return {
      form: {
        quotation_id: "",
        receipt_port_id: "",
        receiving_person_id: "",
        delivered_in: "",
        purchase_order_details: [
          {
            category_id: "",
          },
        ],
      },

      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.crew = await axios.post("/purchase_orders", this.form);
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/procurement-management/purchase-orders");
      } catch (e) {
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
